/*
* @TagTable.vue
* @Description 组件 异常日志
* @Author 
* @Date 
*/
<template>
    <div class="table-item-box _padding-l-none" style="padding: 10px;">
        <section style="height: 100%;">

            <!-- 表格 -->
            <el-table :data="logInfos"
                      @sort-change="changeSort"
                      ref="multipleTable"
                      stripe
                      :class="{'table': true, 'no-pagination': false}">
                <el-table-column label="请求路径" width="200px">
                    <template v-slot="scope">
                        <span :title="scope.row.requestUri" @click="rowDetail(scope.row, scope.$index)">
                            <el-link type="primary" style="color: #FFFFFF;">{{ scope.row.requestUri }}</el-link>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="访问地址" width = "150px">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="scope.row.requestIp">{{ scope.row.requestIp }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="异常日志">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;"
                              :title="scope.row.excMessage" @click="rowDetail(scope.row, scope.$index)">
                            <el-link type="primary" style="color: #FFFFFF;">{{ scope.row.excMessage }}</el-link>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作时间" :sortable="filters.sortable" prop="create_time"
                                 :sort-orders="filters.sortOrders" width="180px">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="scope.row.time">{{ scope.row.time }}</span>
                    </template>
                </el-table-column>
            </el-table>

            <!--分页工具条-->
            <Pagination
                :currentPage="pagination.currentPage"
                :total="pagination.total"
                :pageSize="pagination.limit"
                @handleSizeChangeSub="handleSizeChangeSub"
                @handleCurrentChangeSub="handleCurrentChangeSub"
            />

          <!--查询工具条-->
          <el-col style="text-align: left;">
            <el-form :inline="true" :model="filters" ref="filters">
              <el-form-item>查询条件：</el-form-item>
              <el-form-item prop="duration" class="item-cnt-lhfs-0">
                <el-date-picker
                    :picker-options="filters.pickerOptions"
                    v-model="filters.duration"
                    type="datetimerange"
                    range-separator="—"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="操作开始时间"
                    end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item prop="keyword">
                <el-input v-model="filters.keyword" placeholder="请输入操作用户/访问路径" clearable
                          @keyup.enter.native="research" :style="{width: '300px'}">
                  <i slot="suffix" class="el-input__icon el-icon-search" @click="research"></i>
                </el-input>
              </el-form-item>
            </el-form>
          </el-col>

            <ExceptionLogDialog ref="exceptionLogDialog"/>

        </section>
    </div>

</template>

<script>
// 日志组件
import ApiLog from '@/request/api-log'
// 分页组件
import Pagination from '@/components/Pagination.vue'
import ExceptionLogDialog from './ExceptionLogDialog'

export default {
    name: "ExceptionLogTable",
    /**
     * @Des 组件引用
     * @Auth jsh
     * @Date 09:41 2021/6/28
     */
    components: {
        // 分页工具
        Pagination,
        ExceptionLogDialog
    },
    /**
     * @Des 数据定义
     * @Auth jsh
     * @Date 09:41 2021/6/28
     */
    data() {
        return {
            /**
             * @Des 查询条件属性
             * @Auth jsh
             * @Date 09:41 2021/6/28
             */
            filters: {
                keyword: '',
                orderBy: {
                    "create_time": "desc"
                },
                sortOrders: [
                    "ascending",
                    "descending"
                ],
                sortable: 'custom',
                // 开始时间 - 结束时间
                duration: '',
                // 隐藏的时间
                pickerOptions: {
                    disabledDate(v) {
                        return v.getTime() > new Date().getTime()
                    }
                },
            },
            // 操作模块
            modules: [],
            // 日志集合
            logInfos: [],
            locked: false,
            /**
             * @Des 分页数据
             * @Auth
             * @Date 2021/6/4
             */
            pagination: {
                total: 0,
                startNum: 0,
                limit: 50,
                currentPage: 1
            },
        }
    },
    computed: {},
    /**
     * @Des 监听
     * @Auth
     * @Date 2021/6/4
     */
    watch: {
        pagination: {
            handler(newVal, oldVal) {
                this.searchLog();
            },
            immediate: true,
            deep: true,
        }
    },
    created() {
        // 查询操作模块
        this.searchLog();
    },
    mounted() {
    },
    /**
     * @Des 方法定义
     * @Auth jsh
     * @Date 09:42 2021/6/28
     */
    methods: {
        /**
         * 查询组织结构
         * */
        searchLog() {
            let startTime = '';
            let endTime = '';
            if (this.filters.duration) {
                startTime = this.filters.duration[0];
                endTime = this.filters.duration[1];
            }
            // console.log(startTime, endTime);
            this.$request.postJsonRequest(ApiLog.searchException, {
                keyword: this.filters.keyword,
                startTime: startTime,
                endTime: endTime,
                orderBy: this.filters.orderBy,
                startNum: this.pagination.startNum,
                limit: this.pagination.limit,
                total: this.pagination.total
            }).then(result => {
                this.logInfos = [];
                this.pagination.total = result.total;
                if (result.total > 0) {
                    result.rows.forEach((row, index) => {
                        row.time = this.$moment(row.createTime).format('YYYY-MM-DD HH:mm:ss')
                        this.logInfos.push(row);
                    })
                }
                // console.log(this.logInfos)
            }).catch(error => {
                console.error('查询异常日志异常', ApiLog.searchException, error);
            })
        },

        /**
         * 是否选择
         * */
        checkSelectable(row) {
            return true;
        },
        /**
         * 重新搜索
         * */
        research() {
            this.pagination.total = 0;
            this.pagination.startNum = 0;
            this.searchLog();
        },
        /**
         * 改变排序
         * */
        changeSort(data) {
            let prop = data.prop;
            let order = data.order;
            if (order == null) {
                order = this.filters.orderBy[prop];
            } else {
                order = order.replace("ending", "");
            }
            if (order == null) {
                this.filters.orderBy["create_time"] = "desc";
            } else {
                this.filters.orderBy = {};
                this.filters.orderBy[prop] = order;
            }
            this.research();
        },

        /**
         * @Des 当前页数据改变
         * @Auth
         * @Date 2021/6/4
         */
        handleCurrentChangeSub(val) {
            this.pagination.currentPage = val;
            this.pagination.startNum = this.pagination.limit * (val - 1);
        },
        /**
         * @Des 页长度改变
         * @Auth
         * @Date 2021/6/4
         */
        handleSizeChangeSub(val) {
            this.pagination.limit = val;
            this.pagination.currentPage = 1;
            this.pagination.startNum = 0;
        },
        /**
         * 行明细
         * @param row
         * @param index
         */
        rowDetail(row, index){
            this.$refs.exceptionLogDialog.openDialog(row, index);
        }
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components_pages/Log/ExceptionLogTable.vue